export const propertyTypeLabels: Record<string, string> = {
  "short-term": "Vacation Rental",
  "commercial": "Commercial",
  "long-term": "Long-Term Rental",
};

export const placeholderProperties = [
  {
    id: "1",
    title: "Cozy Mountain Cabin",
    description: "A beautiful retreat nestled in the mountains with stunning views and modern amenities. Perfect for a romantic getaway or family vacation.",
    property_type: "short-term" as const,
    price: 150,
    price_period: "night",
    bedrooms: 2,
    bathrooms: 1,
    square_feet: 1200,
    city: "Mountain View",
    state: "CO",
    address: "123 Mountain Rd",
    images: ["https://images.unsplash.com/photo-1518780664697-55e3ad937233?ixlib=rb-4.0.3&auto=format&fit=crop&w=480&q=60"],
    features: ["WiFi", "Fireplace", "Mountain Views", "Hot Tub"],
    is_featured: true,
    airbnb_url: "https://airbnb.com",
  },
  {
    id: "2",
    title: "Downtown Office Space",
    description: "Modern office space in the heart of downtown with all amenities. Open floor plan with plenty of natural light.",
    property_type: "commercial" as const,
    price: 2500,
    price_period: "month",
    bedrooms: null,
    bathrooms: 2,
    square_feet: 3000,
    city: "Downtown",
    state: "TX",
    address: "456 Business Ave",
    images: ["https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=480&q=60"],
    features: ["Parking", "Conference Room", "Kitchen", "24/7 Access"],
    is_featured: true,
  },
  {
    id: "3",
    title: "Spacious Family Home",
    description: "Perfect family home in a quiet neighborhood with a large backyard and updated kitchen.",
    property_type: "long-term" as const,
    price: 1800,
    price_period: "month",
    bedrooms: 4,
    bathrooms: 3,
    square_feet: 2400,
    city: "Suburbia",
    state: "CA",
    address: "789 Maple St",
    images: ["https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-4.0.3&auto=format&fit=crop&w=480&q=60"],
    features: ["Garage", "Backyard", "Updated Kitchen", "Laundry"],
    is_featured: true,
  },
  {
    id: "4",
    title: "Lakeside Cottage",
    description: "Charming cottage right on the lake with private dock access. Wake up to stunning water views every morning.",
    property_type: "short-term" as const,
    price: 200,
    price_period: "night",
    bedrooms: 3,
    bathrooms: 2,
    square_feet: 1600,
    city: "Lake Town",
    state: "MN",
    address: "321 Lake Shore Dr",
    images: ["https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?ixlib=rb-4.0.3&auto=format&fit=crop&w=480&q=60"],
    features: ["Lake Access", "Private Dock", "Kayaks", "Fire Pit"],
    is_featured: false,
    airbnb_url: "https://airbnb.com",
  },
];
